<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
      showHelp
      :helpText='helpText'
    >
      <template v-slot:appendTitle>
        <span class='caption ml-2 grey--text font-italic' style='letter-spacing: -0.4px !important;'>
          (possible extras)
        </span>
      </template>
      <v-card-text class='py-2 d-flex'>
        <span class='text-subtitle-2 mr-2' style='white-space: nowrap'>Option 1:</span>
        <span v-if='!estimateDetail.add_option_1' class='grey--text text--lighten-1'>None...</span>
        <span v-html='estimateDetail.add_option_1'></span>
        <v-spacer></v-spacer>
        <span class='text-subtitle-2 my-auto mr-4'>{{ estimateDetail.add_option_1_price | decMoney }}</span>
        <v-simple-checkbox :ripple='false' class='mt-n1' :value='estimateDetail.add_option_1_going_fwd'></v-simple-checkbox>
      </v-card-text>
      <v-card-text class='pt-0 pb-2 d-flex'>
        <span class='text-subtitle-2 mr-2' style='white-space: nowrap'>Option 2: </span>
        <span v-if='!estimateDetail.add_option_2' class='grey--text text--lighten-1'>None...</span>
        <span v-html='estimateDetail.add_option_2'></span>
        <v-spacer></v-spacer>
        <span class='text-subtitle-2 mr-4'>{{ estimateDetail.add_option_2_price | decMoney }}</span>
        <v-simple-checkbox :ripple='false' class='mt-n1' :value='estimateDetail.add_option_2_going_fwd'></v-simple-checkbox>
      </v-card-text>
      <v-card-text class='pt-0 pb-2 d-flex'>
        <span class='text-subtitle-2 mr-2' style='white-space: nowrap'>Option 3: </span>
        <span v-if='!estimateDetail.add_option_3' class='grey--text text--lighten-1'>None...</span>
        <span v-html='estimateDetail.add_option_3'></span>
        <v-spacer></v-spacer>
        <span class='text-subtitle-2 mr-4'>{{ estimateDetail.add_option_3_price | decMoney }}</span>
        <v-simple-checkbox :ripple='false' class='mt-n1' :value='estimateDetail.add_option_3_going_fwd'></v-simple-checkbox>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      width='800'
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row>
          <v-col cols='8'>
            <v-text-field
              label='Option 1'
              v-model='estimateDetailCopy.add_option_1'
              :rules='estimateDetailCopy.add_option_1_going_fwd ? [rules.required] : []'
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols='2'>
            <v-text-field
              label='Price'
              v-model='estimateDetailCopy.add_option_1_price'
              :rules='estimateDetailCopy.add_option_1_going_fwd ? [rules.decimal] : [rules.decimalOrEmpty]'
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols='2'>
            <v-checkbox
              label='Going forward?'
              hide-details
              v-model='estimateDetailCopy.add_option_1_going_fwd'
              @change='validateForm'
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='8'>
            <v-text-field
              label='Option 2'
              v-model='estimateDetailCopy.add_option_2'
              :rules='estimateDetailCopy.add_option_2_going_fwd ? [rules.required] : []'
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols='2'>
            <v-text-field
              label='Price'
              v-model='estimateDetailCopy.add_option_2_price'
              :rules='estimateDetailCopy.add_option_2_going_fwd ? [rules.decimal] : [rules.decimalOrEmpty]'
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols='2'>
            <v-checkbox
              label='Going forward?'
              hide-details
              v-model='estimateDetailCopy.add_option_2_going_fwd'
              @change='validateForm'
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='8'>
            <v-text-field
              label='Option 3'
              v-model='estimateDetailCopy.add_option_3'
              :rules='estimateDetailCopy.add_option_3_going_fwd ? [rules.required] : []'
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols='2'>
            <v-text-field
              label='Price'
              v-model='estimateDetailCopy.add_option_3_price'
              :rules='estimateDetailCopy.add_option_3_going_fwd ? [rules.decimal] : [rules.decimalOrEmpty]'
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols='2'>
            <v-checkbox
              label='Going forward?'
              hide-details
              v-model='estimateDetailCopy.add_option_3_going_fwd'
              @change='validateForm'
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'irrigation-estimate-options',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    title: 'Options',
    icon: 'mdi-format-list-checks',
    iconColor: 'info',
    isFormValid: false,
    estimateDetailCopy: {},
    showDialog: false,
    helpText: "These options will appear beneath the quote amount box at the bottom of the estimate printout and are not included in the quote amount.<br><br>An Action tracker will be added to an invoice page displaying optional items that have been marked as 'going forward'.<br><br>These will not be included in the invoice amount, and will need to be added as separate line items."

  }),
  methods: {
    openEdit () {
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    save () {
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.$emit('update', this.estimate)
      this.showDialog = false
    },
    validateForm () {
      this.$nextTick(() => {
        this.$refs.form.validate()
      })
    }
  },
  components: {

  }
}
</script>